import { TableHeadersType } from '../tableHeadersType';

export const STOCK_ITEM_HEADER: TableHeadersType[] = [
  {
    "label": "SKU Number",
    "value": "SKU",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Stock Name",
    "value": "stock_item_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Stock Group Name",
    "value": "stock_group_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Stock Unit Name",
    "value": "stock_unit_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "ADDED/MODIFIED BY",
    "value": "updated_by",
    "defaultChecked": true,
    "checked": true
  },
  // {
  //   "label": "Last Updated At",
  //   "value": "updated_at",
  //   "defaultChecked": true,
  //   "checked": true
  // }
]
